module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1.5em",
      "font-size": "150%"
    }
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "fronthead2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_c1#c1",
      "id": "tc1"
    }
  }, [_vm._v("MEMORANDUM OF HENRY SEQUERRA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_c2#c2",
      "id": "tc2"
    }
  }, [_vm._v("NARRATIVE OF DR PHILIP ARDOWER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_c3#c3",
      "id": "tc3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MY INTERVENTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_c4#c4",
      "id": "tc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NARRATIVE OF OLURA MANOLI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_c5#c5",
      "id": "tc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MY COMMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_c6#c6",
      "id": "tc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTINUATION OF DR ARDOWER’S NARRATIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_c7#c7",
      "id": "tc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECRET AND PERSONAL")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58640ff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_toc.vue
// module id = 84
// module chunks = 0